<template>
    <div class="d-flex align-items-center" :style="{ opacity: disabled ? 0.6 : 1 }" @click="!disabled ? $emit('click') : ''" :class="{ 'cursor-pointer': !disabled }">
        <div class="icon-button">
            <font-awesome-icon :icon="[iconVariant, icon]"/>
        </div>
        <div class="ml-2">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FlatRoundedIconButton',
    props: {
        icon: {
            type: String,
            required: true
        },
        iconVariant: {
            type: String,
            default: 'far'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.icon-button {
    width: 35px;
    height: 35px;
    background: #f8f8f8;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
